import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function findAll(payload) {
  const { groupId, farmId } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/inseminators`,
    getHeaders(false, null)
  );
}

export function save(payload) {
  const { groupId, farmId, id, body } = payload;
  if (id === null) {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/inseminators`,
      body,
      getHeaders(false, null)
    );
  } else {
    return apiAnimals.patch(
      `/bovexo/${groupId}/farms/${farmId}/inseminators/${id}`,
      body,
      getHeaders(false, null)
    );
  }
}

export function destroy(payload) {
  const { groupId, farmId, id } = payload;

  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/inseminators/${id}`,
    getHeaders(false, null)
  );
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;

  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/inseminators/${id}/inactivate`,
    null,
    getHeaders(false, null)
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;

  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/inseminators/${id}/activate`,
    null,
    getHeaders(false, null)
  );
}
